export function isUpToDateMarker(item) {
  return item && String(item.status || "").toLowerCase() === "up to date"
}

export function pendingWindowsUpdates(list) {
  if (!Array.isArray(list)) return []
  return list.filter(
    (update) =>
      update &&
      !isUpToDateMarker(update) &&
      (update.Version || update.updateId || update.KB || update.kb || update.Title)
  )
}

export function countPendingWindowsUpdates(list) {
  return pendingWindowsUpdates(list).length
}

export function hasPendingWindowsUpdates(list) {
  return countPendingWindowsUpdates(list) > 0
}

export function pendingOsUpdates(list) {
  if (!Array.isArray(list)) return []
  return list.filter(
    (update) =>
      update &&
      !isUpToDateMarker(update) &&
      (update.Title || update.name || update.package || update.Version)
  )
}

export function countPendingOsUpdates(list) {
  return pendingOsUpdates(list).length
}

export function pendingAppUpdates(list) {
  if (!Array.isArray(list)) return []
  return list.filter(
    (update) => update && update.name && update.availableVersion
  )
}

export function countPendingAppUpdates(list) {
  return pendingAppUpdates(list).length
}

export function hasPendingAppUpdates(list) {
  return countPendingAppUpdates(list) > 0
}

export function uniqueUpdateUsers(users) {
  if (!Array.isArray(users)) return []
  const seen = new Set()
  return users.filter((user) => {
    const key = user?.key || `${user?.hostname || ""}::${user?.user || ""}`
    if (!key || seen.has(key)) return false
    seen.add(key)
    return true
  })
}

export function uniqueUpdateDeviceCount(users) {
  return uniqueUpdateUsers(users).length
}

export function normalizeCatalogDeviceStatus(status) {
  const value = String(status || "").trim().toLowerCase()
  if (value === "online") return "Online"
  if (value === "away") return "Away"
  if (value === "offline") return "Offline"
  return null
}

/** Keep only devices matching Online / Offline / Away (empty = all). */
export function filterCatalogUsersByStatus(users, statusFilter) {
  const all = uniqueUpdateUsers(users)
  if (!statusFilter) return all
  const wanted = normalizeCatalogDeviceStatus(statusFilter)
  if (!wanted) return all
  return all.filter(
    (user) => normalizeCatalogDeviceStatus(user?.deviceStatus) === wanted
  )
}

export function filterCatalogRowsByDeviceStatus(rows, statusFilter) {
  if (!Array.isArray(rows)) return []
  if (!statusFilter) return rows
  return rows
    .map((row) => {
      const users = filterCatalogUsersByStatus(row?.users, statusFilter)
      if (!users.length) return null
      return { ...row, users }
    })
    .filter(Boolean)
}

export function catalogStatusBreakdown(users) {
  const counts = { Online: 0, Away: 0, Offline: 0, Unknown: 0 }
  for (const user of uniqueUpdateUsers(users)) {
    const status = normalizeCatalogDeviceStatus(user?.deviceStatus) || "Unknown"
    counts[status] = (counts[status] || 0) + 1
  }
  return counts
}
